export default "__VITE_ASSET__zLlzyY9D__"